import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Sparkles, PiggyBank, ChefHat, Settings } from "lucide-react";

const Differentials = () => {
  const scrollToCheckout = () => {
    const element = document.getElementById('checkout');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  const differentials = [
    {
      icon: Sparkles,
      title: "Variedade de verdade",
      description: "Combinações pensadas para 30 dias sem repetição chata. Cada receita foi criada para você não enjoar.",
    },
    {
      icon: PiggyBank,
      title: "Economia inteligente",
      description: "Lista única evita compras 'a mais' e desperdícios. Você compra exatamente o necessário.",
    },
    {
      icon: ChefHat,
      title: "Execução simples",
      description: "Panelas e utensílios comuns do dia a dia. Instruções claras e diretas que qualquer um consegue seguir.",
    },
    {
      icon: Settings,
      title: "Flexível e adaptável",
      description: "Cada receita traz substituições e variações para adaptar ao que você tiver em casa no momento.",
    },
  ];

  const examples = [
    {
      title: "Arroz de Forno Cremoso com Frango e Legumes",
      description: "Família ama e rende bem para toda a semana.",
    },
    {
      title: "Macarrão à Bolonhesa Simples",
      description: "O clássico rápido de verdade, pronto em minutos.",
    },
    {
      title: "Omelete Clássica de Queijo e Presunto",
      description: "Salva-vidas do dia corrido, sempre confiável.",
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-muted/30">
      <div className="container">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4">
            Nossos diferenciais
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            O que ninguém te entrega junto
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4 mb-12">
          {differentials.map((item, index) => {
            const Icon = item.icon;
            return (
              <Card 
                key={index}
                className="border-2 animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="pt-6">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-warm">
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="mb-2 text-lg font-bold">{item.title}</h3>
                  <p className="text-sm text-muted-foreground">{item.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <Card className="border-2 border-primary/20 bg-gradient-to-br from-background to-muted/20 max-w-3xl mx-auto">
          <CardContent className="p-8">
            <h3 className="text-2xl font-bold mb-6 text-center">
              Exemplos do que tem lá dentro
            </h3>
            <div className="space-y-4 mb-6">
              {examples.map((example, index) => (
                <div key={index} className="flex gap-3">
                  <div className="shrink-0 mt-1">
                    <div className="h-6 w-6 rounded-full bg-gradient-warm flex items-center justify-center text-white text-sm font-bold">
                      {index + 1}
                    </div>
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">{example.title}</h4>
                    <p className="text-sm text-muted-foreground">{example.description}</p>
                  </div>
                </div>
              ))}
              <p className="text-sm text-muted-foreground italic pt-2">
                ...e muito mais opções com frango, carne, peixe e saladas completas
              </p>
            </div>
            <div className="text-center">
              <Button 
                onClick={scrollToCheckout}
                size="lg"
                className="bg-gradient-warm hover:shadow-hover transition-all duration-300"
              >
                Quero todas as 30 receitas por R$ 29,90
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default Differentials;
